/**
 * Horizontal divider that marks the boundary between read and unread messages
 * in the chat timeline.
 *
 * The divider receives a forwarded ref so `ChatWindow` can scroll it into view
 * when the chat is opened.
 */

import {forwardRef} from "react";
import {Box, Divider, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {NotificationI18N} from "@/translations";

const UnreadDivider = forwardRef<HTMLDivElement>((_props, ref) => {
    const {t} = useTranslation();

    return (
            <Box ref={ref} sx={{display: "flex", alignItems: "center", my: 1, gap: 1}}>
                <Divider sx={{flex: 1, borderColor: "primary.light"}}/>
                <Typography variant="caption" color="primary" sx={{whiteSpace: "nowrap"}}>
                    {t(NotificationI18N.chat.message.unreadDivider)}
                </Typography>
                <Divider sx={{flex: 1, borderColor: "primary.light"}}/>
            </Box>
    );
});

UnreadDivider.displayName = "UnreadDivider";

export default UnreadDivider;
